{
  "intro": "Один адрес перед несколькими серверами: каждый сервис слушает порт и передаёт трафик на порт целей — только тем, кто проходит проверку работоспособности. Оплата почасовая, не больше месячной цены.",
  "empty": "Балансировщиков пока нет",
  "emptyLead": "Балансировщик распределяет трафик между несколькими серверами и перестаёт слать его на сервер, который не прошёл проверку, — сайт продолжает работать, даже если один сервер упал.",
  "create": "Создать балансировщик",
  "newTitle": "Новый балансировщик",
  "newIntro": "Выберите расположение и размер, затем что он передаёт и на какие серверы. Сервисы и цели можно изменить позже.",
  "back": "Все балансировщики",
  "notFound": "Этого балансировщика больше нет.",
  "open": "Открыть",
  "name": "Имя",
  "nameHint": "Чтобы узнавать его в списках, например по сайту, который он обслуживает.",
  "type": "Тип",
  "location": "Расположение",
  "zone": "Сетевая зона {{zone}}",
  "algorithm": "Алгоритм",
  "algorithms": {
    "round_robin": "По очереди",
    "least_connections": "Наименьшее число соединений"
  },
  "algorithmHints": {
    "round_robin": "Каждое новое соединение уходит следующей цели по кругу.",
    "least_connections": "Каждое новое соединение уходит цели, у которой меньше всего открытых соединений."
  },
  "algorithmSave": "Сохранить алгоритм",
  "algorithmSaving": "Меняем алгоритм…",
  "healthTitle": "Состояние",
  "health": {
    "healthy": "Работает",
    "unhealthy": "Не отвечает",
    "partial": "Работает частично",
    "unknown": "Ещё не проверено",
    "none": "Нечего проверять"
  },
  "healthOnPort": "{{port}}: {{status}}",
  "healthyOf": "Работают: {{healthy}} из {{count}}",
  "healthLead": "Балансировщик проверяет каждую цель проверкой каждого сервиса и шлёт трафик только тем, кто её проходит.",
  "openTargets": "Открыть цели",
  "address": "Адрес",
  "addresses": "Адреса",
  "privateOnly": "Только частные сети",
  "services": "Сервисы",
  "noServices": "Нет сервисов",
  "noServicesLead": "Сервис заставляет балансировщик слушать порт и передавать трафик на порт целей, например 443 → 8443.",
  "servicesLead": "Какие порты слушает балансировщик и куда передаёт трафик. Этот тип вмещает до {{max}} сервисов.",
  "targets": "Цели",
  "targetsCount": "Целей: {{count}}",
  "targetsLead": "Куда уходит трафик. Этот тип вмещает до {{max}} целей; каждый сервер, подходящий под селектор меток, считается отдельно.",
  "noTargets": "Нет целей",
  "noTargetsLead": "Добавьте серверы, на которые балансировщик будет слать трафик: по одному, по меткам или по IP-адресу.",
  "target": "Цель",
  "targetKind": "Вид",
  "targetKinds": {
    "server": "Сервер",
    "label_selector": "Селектор меток",
    "ip": "IP-адрес"
  },
  "via": "Как достигается",
  "viaPrivate": "Частная сеть",
  "viaPublic": "Публичный адрес",
  "viaIp": "Этот адрес",
  "addServer": "Добавить сервер",
  "addSelector": "Добавить по меткам",
  "addIp": "Добавить IP-адрес",
  "addTarget": "Добавить цель",
  "addTargetLead": {
    "server": "Целью может быть сервер сетевой зоны {{zone}}.",
    "selector": "Целью станет каждый сервер сетевой зоны {{zone}} с подходящими метками — и те, что будут созданы позже.",
    "ip": "Адрес вне этого проекта, например выделенного сервера. Трафик идёт к нему через интернет."
  },
  "server": "Сервер",
  "serverHint": "Трафик приходит на порт назначения каждого сервиса.",
  "chooseServer": "Выберите сервер",
  "selectorHint": "Например role=web или env in (prod,staging).",
  "ip": "IP-адрес",
  "ipHint": "IPv4 или IPv6.",
  "usePrivateIp": "Через частный адрес",
  "usePrivateIpHint": "Трафик к целям не выходит из частной сети, поэтому им не нужны открытые публичные порты.",
  "usePrivateIpNeedsNetwork": "Нужна частная сеть, в которой есть и балансировщик, и сервер.",
  "targetAdding": "Добавляем цель…",
  "targetRemoving": "Убираем цель…",
  "removeTarget": "Убрать цель",
  "removeTargetTitle": "Убрать {{name}} из балансировщика?",
  "removeTargetConsequence": "Балансировщик перестанет слать туда трафик; сам сервер не изменится.",
  "labelSelectors": "Селекторы меток",
  "labelSelectorsHint": "По одному в строке, например role=web. Целями станут подходящие серверы зоны.",
  "noServersInProject": "В проекте пока нет серверов; цели можно добавить позже.",
  "publicInterface": "Публичный интерфейс",
  "publicInterfaceHint": "Доступен из интернета по собственным IPv4 и IPv6. Без него работает только в своих частных сетях.",
  "on": "Включён",
  "off": "Выключен",
  "enablePublic": "Включить публичный интерфейс",
  "disablePublic": "Выключить публичный интерфейс",
  "enablePublicTitle": "Открыть балансировщик для интернета?",
  "enablePublicConsequence": "Его сервисы снова отвечают на публичных адресах.",
  "disablePublicTitle": "Закрыть балансировщик от интернета?",
  "disablePublicConsequence": "Публичные адреса перестанут отвечать; останутся только частные сети.",
  "publicSwitching": "Меняем публичный интерфейс…",
  "network": "Частная сеть",
  "networks": "Частные сети",
  "networksLead": "Сети, в которых у балансировщика есть адрес; через них он достигает целей.",
  "networkHint": "Необязательно. Нужна, чтобы достигать целей по частным адресам или работать без публичного интерфейса.",
  "noNetwork": "Без частной сети",
  "noNetworkLead": "Балансировщик не подключён ни к одной частной сети.",
  "chooseNetwork": "Выберите сеть",
  "attach": "Подключить к сети",
  "attachTitle": "Подключить к частной сети",
  "attachLead": "Подходят сети с подсетью в сетевой зоне {{zone}}.",
  "attaching": "Подключаем к сети…",
  "fixedIp": "Адрес (необязательно)",
  "fixedIpHint": "Оставьте пустым — будет взят свободный адрес подсети.",
  "privateIp": "Адрес",
  "detach": "Отключить",
  "detachTitle": "Отключить от {{name}}?",
  "detachConsequence": "Цели, которых балансировщик достигает через эту сеть, станут ему недоступны через неё.",
  "detaching": "Отключаем от сети…",
  "dnsV4": "Обратный DNS для IPv4",
  "dnsV6": "Обратный DNS для IPv6",
  "limitsTitle": "Тип и ограничения",
  "maxConnections": "Соединений не больше",
  "trafficOut": "Исходящий трафик за месяц",
  "trafficIncluded": "Включено {{size}}",
  "price": "В месяц",
  "pricePerHour": "В час",
  "pricePerMonth": "В месяц, не больше",
  "pricePair": "{{hourly}} в час, не больше {{monthly}} в месяц",
  "notOffered": "Нет в этом расположении",
  "billing": "Оплата почасовая — от создания до удаления, но не больше месячной цены; трафик сверх включённого оплачивается отдельно.",
  "typeLimits": "Сервисов: {{services}}, целей: {{targets}}, сертификатов: {{certificates}}",
  "typeConnections": "Одновременных соединений до {{count}}",
  "changeType": "Сменить тип",
  "changeTypeLead": "Тип побольше вмещает больше сервисов, целей и соединений; адреса балансировщика остаются прежними.",
  "changeTypeSubmit": "Сменить тип",
  "typeChanging": "Меняем тип…",
  "summary": "Итог",
  "submit": "Создать балансировщик",
  "created": "Балансировщик {{name}} создаётся",
  "createdAt": "Создан",
  "fixErrors": "Некоторые значения нужно поправить — см. отмеченные поля.",
  "stepLocation": "Расположение",
  "stepLocationLead": "Где работает балансировщик. Он шлёт трафик серверам той же сетевой зоны.",
  "stepType": "Размер",
  "stepTypeLead": "Сколько сервисов, целей и соединений он выдерживает.",
  "stepNetwork": "Сеть",
  "stepNetworkLead": "Публичный, частный или оба сразу.",
  "stepAlgorithm": "Алгоритм",
  "stepService": "Первый сервис",
  "stepServiceLead": "Что он слушает и куда передаёт; остальные можно добавить позже.",
  "withService": "Добавить сервис сразу",
  "stepTargets": "Цели",
  "stepTargetsLead": "Серверы, которые получают трафик.",
  "stepName": "Имя и метки",
  "saved": "Сохранено",
  "protect": "Защитить от удаления",
  "unprotect": "Снять защиту от удаления",
  "protected": "Защищён",
  "running": "Идёт изменение:",
  "delete": "Удалить балансировщик",
  "deleteTitle": "Удалить балансировщик {{name}}?",
  "deleteAddresses": "Его адрес {{address}} будет освобождён, вернуть его нельзя.",
  "deleteServices": "Все его сервисы сразу перестанут работать.",
  "deleteTargets": "Серверы-цели не изменятся; через него трафик к ним больше не пойдёт.",
  "deleteBilling": "Оплата прекращается с текущим часом.",
  "deleteProtected": "Включена защита от удаления. Сначала снимите её.",
  "deleted": "Балансировщик {{name}} удалён",
  "why": {
    "protected": "Включена защита от удаления",
    "otherZone": "Другая сетевая зона",
    "alreadyTarget": "Уже цель",
    "joined": "Уже подключён",
    "noSubnet": "Нет подсети в зоне балансировщика",
    "currentType": "Текущий тип",
    "tooSmall": "Мал для его сервисов, целей или сертификатов"
  },
  "tabs": {
    "overview": "Обзор",
    "services": "Сервисы",
    "targets": "Цели",
    "networking": "Сеть",
    "type": "Сменить тип",
    "settings": "Имя и метки",
    "delete": "Удаление"
  },
  "tabIntro": {
    "overview": "Адреса, состояние, алгоритм и ограничения.",
    "services": "Порты, которые слушает балансировщик, и порты целей, на которые он передаёт трафик.",
    "targets": "Серверы и адреса, которые получают трафик, и их состояние по каждому сервису.",
    "networking": "Публичный интерфейс и частные сети.",
    "type": "Размер балансировщика.",
    "settings": "Имя и метки.",
    "delete": "Удалить балансировщик и освободить его адреса."
  },
  "service": {
    "add": "Добавить сервис",
    "addTitle": "Новый сервис",
    "editTitle": "Сервис на порту {{port}}",
    "lead": "Слушать порт A и передавать на порт B каждой работающей цели.",
    "adding": "Добавляем сервис {{listen}} → {{destination}}…",
    "saving": "Сохраняем сервис {{listen}} → {{destination}}…",
    "edit": "Изменить",
    "delete": "Удалить сервис",
    "deleteTitle": "Удалить сервис {{service}}?",
    "deleteStops": "Балансировщик перестанет отвечать на порту {{port}}.",
    "deleting": "Удаляем сервис…",
    "forward": "Слушает → передаёт на",
    "forwardSummary": "Клиенты подключаются к порту {{listen}}; балансировщик передаёт трафик на порт {{destination}} целей.",
    "protocol": "Протокол",
    "protocolHints": {
      "tcp": "Передаёт соединения как есть, для любого протокола (TLS проходит без изменений).",
      "http": "Читает HTTP-запросы: доступны «липкие» сессии и HTTP-проверки.",
      "https": "Завершает TLS на балансировщике вашим сертификатом и передаёт целям обычный HTTP."
    },
    "listenPort": "Порт приёма",
    "listenHint": "Куда подключаются клиенты.",
    "listenFixed": "Порт приёма у сервиса не меняется; для другого порта добавьте новый сервис.",
    "destinationPort": "Порт назначения",
    "destinationHint": "Куда трафик приходит на целях.",
    "portInvalid": "Порт от 1 до 65535.",
    "certificates": "Сертификаты",
    "certificatesHint": "Сертификат, который балансировщик показывает по HTTPS; несколько сертификатов покрывают несколько доменов.",
    "noCertificates": "В проекте пока нет сертификатов.",
    "openCertificates": "Добавить сертификат",
    "certificateNeeded": "Выберите хотя бы один сертификат.",
    "redirectHttp": "Перенаправлять HTTP на HTTPS",
    "redirectHttpHint": "Обычные запросы на порт 80 получат перенаправление на этот сервис. Порт 80 должен быть свободен.",
    "sticky": "«Липкие» сессии",
    "stickyHint": "Cookie удерживает каждого клиента на одной и той же цели.",
    "proxyProtocol": "PROXY protocol",
    "proxyProtocolHint": "Передаёт целям адрес клиента; цели должны его ожидать, иначе отвергнут трафик.",
    "options": "Параметры",
    "redirectShort": "HTTP → HTTPS",
    "stickyShort": "Липкие сессии",
    "proxyShort": "PROXY",
    "healthCheck": "Проверка работоспособности",
    "healthCheckHint": "Как балансировщик узнаёт, что цель может принимать трафик. Цель, не прошедшая проверку, не получает трафика, пока снова её не пройдёт.",
    "checkSummary": "{{protocol}} на порт {{port}} {{path}}, каждые {{interval}} с",
    "moreCheck": "Настроить проверку",
    "lessCheck": "Скрыть",
    "checkProtocol": "Протокол проверки",
    "checkPort": "Порт проверки",
    "interval": "Интервал, секунд",
    "timeout": "Тайм-аут, секунд",
    "retries": "Попыток",
    "retriesHint": "Сколько проверок подряд должно провалиться, чтобы цель считалась неработающей.",
    "secondsInvalid": "Целое число секунд.",
    "retriesInvalid": "Целое число, от 0.",
    "path": "Путь",
    "pathInvalid": "Начинается с /.",
    "domain": "Заголовок Host",
    "domainHint": "Необязательно: домен, который отправляется с проверкой.",
    "statusCodes": "Допустимые коды ответа",
    "statusCodesHint": "Через запятую; ? — любая цифра, например 2??, 301.",
    "codesInvalid": "Коды вида 200 или 2??.",
    "response": "Ожидаемый текст",
    "responseHint": "Необязательно: ответ должен его содержать.",
    "tls": "Проверять по HTTPS",
    "tlsHint": "Для целей, которые на порту проверки отвечают только по HTTPS.",
    "cookieName": "Имя cookie",
    "cookieNameHint": "Пусто — значение провайдера по умолчанию.",
    "cookieLifetime": "Время жизни cookie, секунд",
    "every": "каждые {{seconds}} с"
  }
}
